<div class="modal-header">
    <h4 class="modal-title">{{ title }}</h4>
</div>
<form name="form" #form="ngForm">
    <div class="modal-body">
        <div class="row">
            <div class="col-12">
                <div class="form-group">
                    <label for="txbxName">Survey Name</label>
                    <input id="txbxName" type="text" class="form-control" [(ngModel)]="target.name" name="name" required maxlength="100" />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <label for="numberSent">Number Sent Out</label>
                    <input id="numberSent" type="number" class="form-control" [(ngModel)]="target.numberSent" name="numberSent" />
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label for="numberCompleted">Number Completed</label>
                    <input
                        id="numberCompleted"
                        type="number"
                        class="form-control"
                        [(ngModel)]="target.numberCompleted"
                        name="numberCompleted"
                    />
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-6">
                <div class="form-group">
                    <label for="numberOfFollowUps">Number of Follow Ups</label>
                    <input
                        id="numberOfFollowUps"
                        type="number"
                        class="form-control"
                        [(ngModel)]="target.numberOfFollowUps"
                        name="numberOfFollowUps"
                    />
                </div>
            </div>
            <div class="col-6">
                <div class="form-group">
                    <label for="numberOfTrainings">Number of Trainings</label>
                    <input
                        id="numberOfTrainings"
                        type="number"
                        class="form-control"
                        [(ngModel)]="target.numberOfTrainings"
                        name="numberOfTrainings"
                    />
                </div>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button id="btnSave" type="submit" class="btn btn-primary" (click)="save()" [disabled]="form.invalid || isSaving">
            @if (isSaving) {
                <span><fa-icon [icon]="faSpinner" [animation]="'spin'"></fa-icon>&nbsp;Saving</span>
            } @else {
                <span>Save</span>
            }
        </button>
        <button id="btnCancel" type="button" class="btn btn-secondary" (click)="cancel()" [disabled]="isSaving">Cancel</button>
    </div>
</form>
